import { render, staticRenderFns } from "./TS01.vue?vue&type=template&id=db7c1b6c&scoped=true&"
import script from "./TS01.vue?vue&type=script&lang=js&"
export * from "./TS01.vue?vue&type=script&lang=js&"
import style0 from "./TS01.vue?vue&type=style&index=0&id=db7c1b6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7c1b6c",
  null
  
)

export default component.exports